export enum EmployeeIdentificationType {
  PersonalIdentityNumber = 'Person nr',
  CoOrdinationNumber = 'Samordningspers nr',
}

export const identificationTypeFromString = (identificationType: string): EmployeeIdentificationType => {
  switch (identificationType) {
    case 'Person nr':
      return EmployeeIdentificationType.PersonalIdentityNumber;
    case 'Samordningspers nr':
      return EmployeeIdentificationType.CoOrdinationNumber;
    default:
      return EmployeeIdentificationType.PersonalIdentityNumber;
  }
};
